export const palette = {
    primary: {
        main: '#130739',
        contrastText: '#FFFFFF'
    },
    secondary: {
        main: '#00F9CF',
        contrastText: '#130739'
    }
} as const;